<template>
  <Modal v-model="visible" :mask-closable="false" title="添加产品" width="1000px" class="my-modal" :footer-hide="true">
    <Tabs v-model="sourceType" @on-click="resetSearch">
      <TabPane label="平台产品" name="platform"></TabPane>
      <TabPane label="自建产品" name="my"></TabPane>
    </Tabs>
    <div class="search-box min">
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">产品编码</span>
        <Input v-model="searchParams.productCode" placeholder="请输入" clearable />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="getList()">搜索</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" v-if="tableData.length">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="sel(row)">选择</span>
        </template>
      </Table>
      <no-data v-else-if="!listLoading" style="margin-top: 250px"></no-data>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>
  </Modal>
</template>
<script>
import { pageTool } from '@/api/mixins';
export default {
  mixins: [pageTool],
  data: () => ({
    visible: false,
    sourceType: 'platform',
    columns: [
      {
        title: '序号',
        type: 'index',
        align: 'center',
        width: 80
      },
      {
        title: '产品名称',
        key: 'productName',
        align: 'center',
        minWidth: 170
      },
      {
        title: '产品编码',
        key: 'productCode',
        align: 'center',
        minWidth: 170
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        fixed: 'right',
        width: 100
      }
    ],
    searchParams: {}
  }),
  components: {},
  created() {},
  methods: {
    open() {
      this.searchParams = {
        isGift: '0',
        publishStatus: '2',
        salesStatus: '2'
      }
      this.initListAjax('/buz/productBase/read/list');
      this.visible = true;
    },
    setListParams(params) {
      if(this.sourceType == 'platform') {
        params.sourceTypes = [1, 3];
      } else {
        params.sourceTypes = [2];
      }
    },
    sel(item) {
      this.$emit('select', item);
      this.visible = false;
    },
  }
};
</script>
<style lang='scss' scoped>
</style>